// Function to position promo blocks based on their order index
  function dypPositionPromoBlocks() {
    const mealGrids = document.querySelectorAll('.design-your-plan-meals-grid-wrap');
    
    mealGrids.forEach(function(grid) {
      const mealListContainer = grid.querySelector('.meal-list');
      const promoBlocks = mealListContainer.querySelectorAll('.meal-item-promo-block');
      const mealItems = mealListContainer.querySelectorAll('.product-meal-item:not(.meal-item-promo-block)');
      
      promoBlocks.forEach(function(promoBlock) {
        const orderIdx = parseInt(promoBlock.getAttribute('data-order-idx'));
        if (orderIdx > 0 && orderIdx <= mealItems.length) {
          // Insert before the meal at the specified index (1-based to 0-based conversion)
          const targetMeal = mealItems[(orderIdx+2) - 1];
          if (targetMeal) {
            mealListContainer.insertBefore(promoBlock, targetMeal);
          }
        } else if (orderIdx > mealItems.length) {
          // If order index is greater than meal count, append to end of meals
          const lastMeal = mealItems[mealItems.length - 1];
          if (lastMeal) {
            mealListContainer.insertBefore(promoBlock, lastMeal.nextSibling);
          }
        }
        // If orderIdx is 0 or negative, leave the promo block where it is
      });
    });
  }


function dypFilterInit(){
  $(".design-your-plan-meals-grid-wrap").each(function (index) {
      
      const productMealItems = $(this).find(".meal-list .product-meal-item");
      $(productMealItems).each(function (index) {
        $(this).data("default-sort-score",productMealItems.length - index);
        //$(this).data("default-sort",index);
      });
    });
    $(".filter-matched-heading").data("default-sort-score", 50000);
    $(".filter-non-matched-heading").data("default-sort-score", 9999);
    
   $(".design-your-plan-meal-filter-wrap").find(".tags-filter").click((e) => {
      dypShowAdvFilter();
    });

    $(".design-your-plan-meal-filter-tags").find(".close-filter").click((e) => {
      dypCloseAdvFilter();
    });
    $(".design-your-plan-meal-filter-tags").click((e) => {
    
      dypCloseAdvFilter();
    }).children().click(function(e) {
      return false;
    });

    $(".design-your-plan-meal-filter-wrap").find(".type-filter-btn").click((e) => {
      dypFilterClickHandler(e.currentTarget, "filter", $(".design-your-plan-meal-filter-wrap"), $(".design-your-plan-meal-filter-tags"), $(".design-your-plan-meals-selection-container"));
    });
    $(".design-your-plan-meal-filter-tags").find(".tag-filter-btn").click((e) => {
      if ($(e.currentTarget).data("tag").includes("use-by") ){
        $(".design-your-plan-meal-filter-tags").find(".tag-filter-btn").each(function(){
          if ($(this).data("tag").includes("use-by") ){
            $(this).removeClass("clicked");
          }
        });
      }
      dypFilterClickHandler(e.currentTarget, "advFitler", $(".design-your-plan-meal-filter-wrap"), $(".design-your-plan-meal-filter-tags"), $(".design-your-plan-meals-selection-container"));
    });  
    
    $("#filter-sort-list").on( "change", function() {
        dypFilterClickHandler(null, "sorting", $(".design-your-plan-meal-filter-wrap"), $(".design-your-plan-meal-filter-tags"), $(".design-your-plan-meals-selection-container"));
    } );

}
function dypShowAdvFilter(){
    $(".design-your-plan-meal-filter-tags").addClass("show");
    $("body").addClass("overflow-y-hidden");
  }
function dypCloseAdvFilter(){
  $(".design-your-plan-meal-filter-tags").removeClass("show");
  $("body").removeClass("overflow-y-hidden");
}

function dypFilterClickHandler(target, type, filterContainer, advancedFilterContainer, mealsContainer){
    var typeFilterString = [];
    var $this =$(target);

    
    if (type == "sorting"){
      //type: sorting

      
    } else if (type == "filter"){
      //filter button click
      if ($this.data("type") != "All") {
        filterContainer.find(".type-filter-btn-all").removeClass("active");
      
        // if ($this.hasClass("active")){
        //   $this.removeClass("active");
        // } else {
        //   $this.addClass("active");
        // }
        $this.toggleClass("active");
        

        //sync advFitler
        if (["low-cal","high protein","low carb","low fat"].includes($this.data("type"))){
          advancedFilterContainer.find(".tag-filter-btn").each(function () {
            if ($(this).data("tag") == $this.data("type")){
              if ($this.hasClass("active")){
                $(this).addClass("clicked");
              } else {
                $(this).removeClass("clicked");
              }
              
            }
          });
          
        }

        //check if use by date conflict 
        if ($this.data("type") == "use-by-6-days" && $this.hasClass("active")){
          $("#filter-btn-use-by-5-days").removeClass("active");
        }
        if ($this.data("type") == "use-by-5-days" && $this.hasClass("active")){
          $("#filter-btn-use-by-6-days").removeClass("active");
        }
      } 
      else {
        filterContainer.find(".type-filter-btn").removeClass("active");  
        advancedFilterContainer.find(".tag-filter-btn").removeClass("clicked");
       
      }

    } else {
      //adv filter button click
      //console.log("adv filter btn click------");
      $this.toggleClass("clicked");
      //sync advFitler
      if (["low-cal","high protein","low carb","low fat"].includes($this.data("tag"))){
        filterContainer.find(".type-filter-btn").each(function () {
          if ($(this).data("type") == $this.data("tag")){
            if ($this.hasClass("clicked")){
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            
            }
          }
        });
      }
    } // end check type
    

    //add active filter to typeFilterString array
    filterContainer.find(".type-filter-btn").each(function(){
      var $this = $(this);
      if ($this.hasClass("active")){
        if (!typeFilterString.includes($this.data("type"))){
          typeFilterString.push($this.data("type")); 
        }
        
      }
    })

    //add active adv filter to typeFilterString array
    advancedFilterContainer.find(".tag-filter-btn").each(function(){
      var $this = $(this);
      if ($this.hasClass("clicked")){
        if (!typeFilterString.includes($this.data("tag"))){
          typeFilterString.push($this.data("tag"));   
        }
        
      }
    })

    
    console.log(typeFilterString);
    
    this.dypFilterHandler(typeFilterString, filterContainer, advancedFilterContainer, mealsContainer);
    
    setTimeout(dypPositionPromoBlocks, 100);
  
  }

  function dypFilterHandler(typeFilterString, filterContainer, advancedFilterContainer, mealsContainer){
    var sortType = "relevance";
    sortType = $("#filter-sort-list").find(":selected").val();
    
    
    $(".filter-matched-heading").html("MEALS BASED ON Filter <br><span>no meals matched</span>");
    if (window?.designYourPlan?.mealPicker?.options?.goals?.length > 0){
      $(".filter-matched-heading").html("MEALS BASED ON Your Goals & Filter <br><span>no meals matched</span>");
    }

    console.log("typeFilterString.length :"+typeFilterString.length );
    if (typeFilterString.length > 0) {
      

      
      
      //console.log(typeFilterString);
      if (!(typeFilterString.length == 1 && typeFilterString[0] =="All")){

      
        $(".meal-list").removeClass("all");
        filterContainer.find(".type-filter-btn-all").removeClass("active");
      }

      
      //transfer goals to type filter string
      if (typeFilterString.includes("goals")){
        //alert(window.designYourPlan.data.goals);
        
        
        var _filterCalConflict = 0;
        var _goals = []
        if (window?.designYourPlan?.mealPicker?.options?.goals?.length > 0){
          _goals = window.designYourPlan.mealPicker.options.goals;
        } else {
          _goals = subscription.preferences.goals;
        }
        _goals.forEach((g) => {
          if (g.toLowerCase() == "weight loss"){
            //typeFilterString.push("low fat");
            typeFilterString.push("low-cal");
            // typeFilterString.push("low carb");
            _filterCalConflict += 1;
          }
          if (g.toLowerCase() == "build muscle"){
            typeFilterString.push("high protein");
          }
          if ((g.toLowerCase() == "gain back more time") ){
            if (_goals.length == 1){
              typeFilterString.push("chefs");
            }
          }
          if ((g.toLowerCase() == "improve overall health") ){
            if (_goals.length == 1){
              typeFilterString.push("chefs");
            }
          }
          if ((g.toLowerCase() == "increase energy and focus levels") ){
            typeFilterString.push("high-cal");
            _filterCalConflict += 1;
          }
          if ((g.toLowerCase() == "fitness + performance") ){
            if (_goals.length == 1){
              typeFilterString.push("chefs");
            }
          }
        });
      }

      if (_filterCalConflict == 2){
        let index = typeFilterString.indexOf("high-cal");
        if (index !== -1) {
          typeFilterString.splice(index, 1);
        }
        index = typeFilterString.indexOf("low-cal");
        if (index !== -1) {
          typeFilterString.splice(index, 1);
        }
      }
      typeFilterString = typeFilterString.filter(item => item != "goals");
      typeFilterString = typeFilterString.filter(item => item != "All");

      console.log("typeFilterString");
      console.log(typeFilterString);
      

      //add sorting score base filter and sort type
      mealsContainer.find(".product-meal-item").each(function () {
        var $this = $(this);
        var mealTags = $this.data("tags");
        let hasAllElemsMatched = true;
        var sortingScore = 0;

        var numFilters = ["high protein", "low fat", "low-cal", "low carb", "high-cal"];

        
        
        var _default_sorting_score = 0;
        //check matched filter and default sorting socre
        for (let i = 0; i < typeFilterString.length; i++) {
          // console.log(typeFilterString[i]);
          // console.log(mealTags);
          // console.log("========================");
          
          if (numFilters.includes(typeFilterString[i])){
            var _s = 0;

            if (typeFilterString[i] == "low-cal"){
              _s = parseFloat($this.data("kcal")) || 1000;
              if (_s <= 500){
                _default_sorting_score += (1000 - _s);
              } else {
                hasAllElemsMatched = false;
              }
            }
            if (typeFilterString[i] == "high-cal"){
              _s = parseFloat($this.data("kcal")) || 1000;
              if (_s > 500){
                _default_sorting_score += (1000 - (1000 -_s));
              } else {
                hasAllElemsMatched = false;
              }
            }

            if (typeFilterString[i] == "high protein"){
              _s = parseFloat($this.data("protein")) || 0;
              if (_s >= 20){
                _default_sorting_score += _s + 500;
              } else {
                hasAllElemsMatched = false;
              }
              // console.log($this.data("protein"));
              // console.log(sortingScore);
            }
            if (typeFilterString[i] == "low carb"){
              _s = parseFloat($this.data("carb")) || 1000;
              if (_s <= 40){
                _default_sorting_score += (1000 - _s);
              } else {
                hasAllElemsMatched = false;
              }
            }
            if (typeFilterString[i] == "low fat"){
              _s = parseFloat($this.data("fat")) || 1000;
              
              if (_s <= 10){
                _default_sorting_score += (1000 - _s);
              } else {
                hasAllElemsMatched = false;
              }
            }
          } else {
            if (!mealTags?.includes(typeFilterString[i])) {
              hasAllElemsMatched = false;
            // break;
            } else {
              _default_sorting_score += 100;
            }

          }
          
        }

        var _sorting_score_by_sort_type = 0;
        if (sortType == "relevance"){
          _sorting_score_by_sort_type = _default_sorting_score
        } else {
          if (sortType == "calorie-low"){
            _s = parseFloat($this.data("kcal")) || 1000;
            _sorting_score_by_sort_type += (1000 - _s);
          }
          if (sortType == "calorie-high"){
            _s = parseFloat($this.data("kcal")) || 1000;
            _sorting_score_by_sort_type += _s;
          }
          if (sortType == "protein-low"){
            _s = parseFloat($this.data("protein")) || 0;
            _sorting_score_by_sort_type += (1000 - _s);
          }
          if (sortType == "protein-high"){
            _s = parseFloat($this.data("protein")) || 0;
            _sorting_score_by_sort_type += _s;
          }
          if (sortType == "price-low"){
            _s = parseFloat($this.data("price")) || 0;
            _sorting_score_by_sort_type += (1000 - _s);
          }
          if (sortType == "price-high"){
            _s = parseFloat($this.data("price")) || 0;
            _sorting_score_by_sort_type += _s;
          }
        }

        if (hasAllElemsMatched) {
          //$this.removeClass("hide");
          //plus 100 if all filter matched
          sortingScore += (10000 + _sorting_score_by_sort_type);
        } else {
          //$this.addClass("hide");
          sortingScore = _sorting_score_by_sort_type;
        }

        //set the header title element to right sorting score
        if ($(this).hasClass("filter-matched-heading") || $(this).hasClass("filter-non-matched-heading")){
          $(this).data("sort-score",$(this).data("default-sort-score"));
        } else {
          $(this).data("sort-score",sortingScore);
        }

        
        
      });

      dypMatchingNsorting();

    } else {
      $(".meal-list").addClass("all");
      filterContainer.find(".type-filter-btn").removeClass("active");  
      advancedFilterContainer.find(".tag-filter-btn").removeClass("clicked");
      filterContainer.find(".type-filter-btn-all").addClass("active");
      // this.mealsContainer.find(".product-meal-item").each(function () {
      //   var $this = $(this);
      //   $this.removeClass("hide");
      // });
      mealsContainer.find(".product-meal-item").each(function () {
        $(this).data("sort-score",$(this).data("default-sort-score"));
      });

      dypMatchingNsorting();
    }
  }


  function dypMatchingNsorting(){

    $(".design-your-plan-meals-grid-wrap.delivery").each(function (index) {
      
      const productMealItemsContainer = $(this).find(".meal-list");
      const productMealItems = $(productMealItemsContainer).find(".product-meal-item");
      
      //check matching result and display matching header
      const matchedMeals = [];
      const nonMatchedMeals = [];
      
      productMealItems.each(function(){
        if ($(this).hasClass("filter-matched-heading") || $(this).hasClass("filter-non-matched-heading")){
          
        } else if (parseInt($(this).data("sort-score")) >= 10000){
          matchedMeals.push($(this));
        } else {
          nonMatchedMeals.push($(this));
        }
      });
      if (matchedMeals.length <= 0){
        $(".filter-matched-heading span").show()
      } else {

        $(".filter-matched-heading span").hide()
      }
      //check matching result and display matching header
      if (nonMatchedMeals.length <= 0){
        $(".filter-non-matched-heading").hide()
      } else {

        $(".filter-non-matched-heading").show()
      }

      $(productMealItemsContainer).append(dypSortedList(productMealItems));
      

    });

  }
  
  function dypSortedList(list){
    return list.sort(function (a, b) {
      
      const contentA = parseInt($(a).data("sort-score"));
      const contentB = parseInt($(b).data("sort-score"));
      
      return contentA > contentB ? -1 : contentA < contentB ? 1 : 0;
    });
  }